import { render } from "./WhatsOurClients.vue?vue&type=template&id=7b14acf1"
import script from "./WhatsOurClients.vue?vue&type=script&lang=js"
export * from "./WhatsOurClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__